import { IonAccordion, IonItem, IonText } from "@ionic/react";
import { useState } from "react";
import { makePOSTRequest } from "../../request/rawRequest";
import "./List.css";
import ListTheme from "./ListTheme";

interface Props {
  name: string | React.ReactNode;
  themesID?: any[];
  compID?: string;
  generique?: boolean;
}

const AccordionItem: React.FC<Props> = ({
  name,
  themesID,
  generique,
  compID,
}) => {
  const [themes, setThemes] = useState([]);
  const [fetch, setFetch] = useState<boolean>(false);

  return (
    <IonAccordion
      onClick={() => {
        if (themes?.length === 0) {
          makePOSTRequest("/themes", { _id: themesID }).then((resThemes) => {
            setThemes(
              resThemes.sort(
                (a: any, b: any) => a?.index - b?.index // video sorting abcdef
              )
            );
            setFetch(true);
          });
        }
      }}
      className="details details-theme border-primary-contrast"
    >
      <IonItem slot="header" color="white" lines="none">
        <IonText color="black" className="margin-15">
          {name}
        </IonText>
      </IonItem>
      <div slot="content">
        {fetch === false ? (
          <IonItem style={{ marginLeft: 5 }}>Chargement en cours....</IonItem>
        ) : (
          <ListTheme
            theme={themes}
            generique={generique ?? false}
            compID={compID ?? undefined}
          />
        )}
      </div>
    </IonAccordion>
  );
};

export default AccordionItem;
